import React, { Component } from 'react'
import { Modal } from "react-bootstrap";
import { Row, Col, Card, Button, Container, Form, Table, InputGroup, Spinner } from "react-bootstrap";
import moment from "moment";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import "./_materialCreation.scss";


const CREATE_MATERIALS = gql`
  mutation($params: CreateMaterials) {
    createMaterials(params: $params)
  }
`;



class MaterialCreationModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            branch: "",
            branchError: "",

            exam: "",
            examError: "",

            class: "",
            classError: "",

            materialtypes: "",
            materialtypesError: "",
            materialName: "",
            materialNameError: "",
            getExams: [],
            getClasses: [],
            materialTypesData: props.getMaterialTypes,
            count: 0,
            update: [],
            dataClear: 1,
            loadingSpinner: 0,
            submitted: false,
            defaultvalue: 0,
            currentStep: 1,
            submitError: "",
            materialsData: [],
            getBranches: [],
            is_grouping: true
        };
    }





    addRow = () => {

        let array = this.state.materialsData

        array.push({ id: null, material_name: "" })

        this.setState({
            materialsData: array
        })

    }

    handleChange = (e, i) => {
        let name = e.target.name;
        let value = e.target.value;

        let array1 = []

        this.state.materialsData.map((item, index) => {
            if (index == i) {
                array1.push({ ...item, material_name: value, materialNameError: "" })
            } else {
                array1.push({ ...item })
            }
        }

        )
        this.setState({ materialsData: array1 })

    }





    deleteHandle = (i) => {

        let updatedRows = this.state.materialsData.filter((item, index) => index != i)
        console.log("hhh", updatedRows, i);
        this.setState({
            materialsData: updatedRows
        })
    }


    handleInputChange = (e, i) => {
        const name = e.target.name;
        const value = e.target.value;
        console.log("nammamm", name, value);

        let getArray = [];

        if (name == "branch") {

            if (value != "0") {
                console.log("value", value);

                let uniqueExams = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == value).map((item1) => item1.exam_id))].sort();

                uniqueExams.map((val) => {
                    let individualExamData = this.props.globals.exams.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualExamData.id,
                        label: individualExamData.exam
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branch: value, branchError: "", exam: "", class: "", getExams: getArray, getClasses: [], classError: "", examError: "", materialtypesError: "", materialNameError:"", materialsData: []

                })


                if(!this.state.is_grouping){
                    //  this.handleChange(e, 0);
                     this.getMaterials(value,"")
                }

            } else {
                this.setState({
                    branch: "", branchError: "", exam: "", class: "", getExams: [], getClasses: [], classError: "", examError: "", materialtypesError: "", materialNameError:"", materialsData: []
                })
            }
        }
        if (name == "exam") {
            if (value != "0") {


                let uniqueClasses = [...new Set(this.props.globals.b_e_c_s_data.filter((item) => item.branch_id == this.state.branch && item.exam_id == value).map((item1) => item1.class_id))].sort();

                uniqueClasses.map((val) => {
                    let individualClassData = this.props.globals.educationalClasses.find((item1) => item1.id == val);
                    const newObj = {
                        value: individualClassData.id,
                        label: individualClassData.class
                    }
                    getArray.push(newObj);
                })

                this.setState({
                    branchError: "", exam: value, class: "", getClasses: getArray, classError: "", examError: "", materialtypesError: "", materialsData: []

                })
            } else {
                this.setState({
                    branchError: "", exam: "", class: "", getClasses: [], classError: "", examError: "", materialtypesError: "", materialsData: []
                })

            }


        }
        if (name == "class") {
            if (value != "0") {

                this.setState({
                    branchError: "", class: value, classError: "", examError: "", materialtypesError: "", materialError:"", materialsData: [],

                })

                // this.handleChange(e, 0);
                this.getMaterials(this.state.branch,value)

            } else {

                this.setState({
                    branchError: "", class: "", classError: "", examError: "", materialtypesError: "", materialNameError:"", materialsData: [],

                })

            }

        }
        if (name == "materialtypes") {
            if (value != "0") {
                console.log("value", value)

                let getBranches = this.props.globals.globalBranches;

                let grouping = this.state.materialTypesData.find((item) => item.id == value).is_grouping == 1 ? true : false

                this.setState({
                    branch: "", branchError: "", exam: "", class: "", getExams: [], getClasses: [], classError: "", examError: "", materialtypesError: "", materialsData: [], getBranches: getBranches, materialtypes: value, is_grouping: grouping

                })
            } else {
                this.setState({
                    branch: "", branchError: "", exam: "", class: "", getExams: getArray, getClasses: [], classError: "", examError: "", materialtypesError: "", materialsData: [], getBranches: [], materialtypes: 0, is_grouping: true
                })
            }
        }
    }




    getMaterials = async (val1,val2) => {
        const result = await this.props.client.query({
            query: gql`
            query($institute_id:Int,$branch_id:Int,$exam_id:Int,$class_id:Int,$material_type_id:Int){
                getMaterials(institute_id:$institute_id,branch_id:$branch_id,exam_id:$exam_id,class_id:$class_id,material_type_id:$material_type_id){
                    id
                    material_name
                  }
               }
            `,
            variables: {
                institute_id: parseInt(Cookies.get("institutionid")),
                branch_id: parseInt(val1),
                exam_id: parseInt(this.state.exam),
                class_id: parseInt(val2),
                material_type_id: parseInt(this.state.materialtypes)
            },
            fetchPolicy: 'network-only'
        })

        if (result.data.getMaterials.length > 0) {
            let data = result.data.getMaterials;
            console.log("materialData", data)
            this.setState({ materialsData: data })
        } else {
            let data = [{ id: null, material_name: "" }]
            this.setState({ materialsData: data })
        }

    }


    handleSubmit = () => {

        if (this.state.materialtypes == "" || this.state.materialtypes == "--Select Material--") {
            this.setState({ materialtypesError: "Please Select Material" })
            return ""
        }

        if (this.state.branch == "" || this.state.branch == "--Select Branch--") {
            this.setState({ branchError: "Please Select Branch" })
            return ""
        }
        if ( this.state.is_grouping && (this.state.exam == "" || this.state.exam == "--Select Exam--")) {
            this.setState({ examError: "Please Select Exam" })
            return ""
        }
        if (this.state.is_grouping && (this.state.class == "" || this.state.class == "--Select Class--")) {
            this.setState({ classError: "Please Select Class" })
            return ""
        }

        let stopExecuting = false;

        this.state.materialsData.some((obj, i) => {

            let errorUpdate = this.state.materialsData

            if (obj.material_name == "" || obj.material_name == undefined) {
                errorUpdate[i] = { ...obj, materialNameError: "Please Type" }
                this.setState({ materialsData: errorUpdate })
                stopExecuting = true
                return true;
            }
        })

        if (stopExecuting) {
            return ""
        }

        let array = []
        if (this.state.materialsData.length > 0) {
            this.state.materialsData.map((item) => {
                array.push({ id: item.id, material_name: item.material_name })
            })
        }

        const params = {
            institute_id: parseInt(Cookies.get("institutionid")),
            branch_id: parseInt(this.state.branch),
            exam_id: parseInt(this.state.exam),
            class_id: parseInt(this.state.class),
            material_type_id: parseInt(this.state.materialtypes),
            materialDetails: array
        }
        console.log("params", params)


        this.setState({
            loadingSpinner: 1
        });

        this.createMaterials(
            params
        ).catch(error => {
            console.log("catch if error");
            console.log(error);
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message), loadingSpinner: 0
            });
            console.error("ERR =>", error.graphQLErrors.map(x => x.message));
        });
    }

    createMaterials = async (
        params) => {
        await this.props.createMaterials({
            variables: {
                params,
            },
            update: (store, { data }) => {
                console.log("data.finishTest", data);
                if (data.createMaterials) {
                    this.setState({
                        loadingSpinner: 0,
                        currentStep: 5
                    })
                    setTimeout(() => {
                        this.props.onHide();
                        window.location.reload(false);
                    }, 1500);
                }
            }

        });
    };



    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "" });
        this.props.onHide();
    };


    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({
                branch: "",
                branchError: "",
                exam: "",
                examError: "",
                class: "",
                classError: "",
                materialtypes: "",
                materialtypesError: "",
                materialName: "",
                materialNameError: "",
                getExams: [],
                getClasses: [],
                materialTypesData: this.props.getMaterialTypes,
                count: 0,
                update: [],
                dataClear: 1,
                loadingSpinner: 0,
                submitted: false,
                defaultvalue: 0,
                currentStep: 1,
                submitError: "",
                materialsData: []
            })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    render() {


        // console.log("materialError",this.state.materialsData.map((item => item.materialNameError)))

        console.log("hari", this.state)
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="example-modal-sizes-title-lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Material Creation</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3">

                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="mt-3">
                            <Form>
                                <Form.Row>

                                    <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectMaterial">
                                        <Form.Label className="text-uppercase font-weight-bold">Material Type</Form.Label>
                                        <Form.Control as="select" name="materialtypes" onChange={this.handleInputChange} value={this.state.materialtypes} isInvalid={this.state.materialtypesError}>
                                            <option value={this.state.defaultvalue}>--Select Material--</option>
                                            {this.state.materialTypesData.map(item1 => (
                                                <option key={item1.id} value={item1.id}>
                                                    {item1.material_type}
                                                </option>
                                            ))
                                            }
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.materialtypesError}
                                        </Form.Text>
                                    </Form.Group>

                                    <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectBranch">
                                        <Form.Label className="text-uppercase font-weight-bold">Branch</Form.Label>
                                        <Form.Control as="select" name="branch" onChange={this.handleInputChange} value={this.state.branch} isInvalid={this.state.branchError}>
                                            <option value={this.state.defaultvalue}>--Select Branch--</option>
                                            {this.state.getBranches.map(branchdata => (
                                                <option key={branchdata.id} value={branchdata.id}>
                                                    {branchdata.branch_name}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="form-text text-danger" type="invalid">
                                            {this.state.branchError}
                                        </Form.Text>
                                    </Form.Group>


                                    {
                                        this.state.is_grouping ? (

                                            <>
                                                <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectExam">
                                                    <Form.Label className="text-uppercase font-weight-bold">Exam</Form.Label>
                                                    <Form.Control as="select" name="exam" onChange={this.handleInputChange} value={this.state.exam} isInvalid={this.state.examError}>
                                                        <option value={this.state.defaultvalue}>--Select Exam--</option>
                                                        {this.state.getExams.map(item => (
                                                            <option key={item.value} value={item.value}>
                                                                {item.label}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                    <Form.Text className="form-text text-danger" type="invalid">
                                                        {this.state.examError}
                                                    </Form.Text>
                                                </Form.Group>


                                                <Form.Group as={Col} lg={3} md={12} sm={12} controlId="SelectClass">
                                                    <Form.Label className="text-uppercase font-weight-bold">Class</Form.Label>
                                                    <Form.Control as="select" name="class" onChange={this.handleInputChange} value={this.state.class} isInvalid={this.state.classError}>
                                                        <option value={this.state.defaultvalue}>--Select Class--</option>
                                                        {this.state.getClasses.map(classdata => (
                                                            <option key={classdata.value} value={classdata.value}>
                                                                {classdata.label}
                                                            </option>
                                                        ))}
                                                    </Form.Control>
                                                    <Form.Text className="form-text text-danger" type="invalid">
                                                        {this.state.classError}
                                                    </Form.Text>
                                                </Form.Group>
                                            </>

                                        ) : ("")
                                    }
                                </Form.Row>
                            </Form>
                        </Col>
                    </Row>

                    <Row>
                        {
                            this.state.materialsData.length > 0 ? (this.state.materialsData.map((item1, i) => (
                                <>
                                    <Col lg={6} md={6} sm={6}>
                                        <div className="row mb-4 mt-1">
                                            <div className="col-sm-3 mbottom">
                                                <input type="text" className="form-control adjust" placeholder="Type here..." onChange={(e) => this.handleChange(e, i)} value={item1.material_name} name="materialName" />
                                                <span className="text-danger row ml-1">{item1.materialNameError}</span>
                                            </div>
                                            <div className="col-sm-3 deleteButton" style={{ marginLeft: "105px" }}>
                                                {
                                                    this.state.materialsData.length > 1 ? (
                                                        // <button onClick={() => this.deleteHandle(i)} className="btn btn-danger "><i className="far fa-trash-alt"/></button>
                                                        <Button variant="link" name="delete" className="text-danger">
                                                            <i className="far fa-trash-alt" onClick={() => this.deleteHandle(i)} />
                                                        </Button>
                                                    ) : ("")
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                </>
                            ))) : ("")
                        }

                    </Row >

                    {
                        this.state.materialsData.length > 0  && this.state.is_grouping ? (
                            <div>
                                <button type="button" onClick={this.addRow} style={{background:"#213046", color:"#ffffff", padding: "6px 12px", borderRadius:"5px"}}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 16">
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                    </svg>
                                </button>
                            </div>
                        ) : ("")
                    }

                </Modal.Body>
                <Modal.Footer variant="white" >
                    <Row>
                        <Col sm={12}>
                            {this.state.currentStep == 5 ? (
                                <Form.Text className="form-text text-success mb-2 " style={{ textAlign: "center" }}>
                                    Material Creation Successfully
                                </Form.Text>
                            ) : (
                                <Form.Text className="form-text text-danger mb-2" style={{ textAlign: "center" }}>
                                    {this.state.submitError}
                                </Form.Text>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12} style={{ display: "block", textAlign: "center" }}>
                            <Button className="text-uppercase" style={{background:"#213046", color:"#ffffff"}} onClick={(e) => this.handleSubmit()}>
                                {
                                    this.state.loadingSpinner == 1 ? (
                                        <span className="spinner-border spinner-border-sm"></span>
                                    ) : ""
                                }
                                Create Material</Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        )
    }
}


export default withRouter(withApollo(compose(
    graphql(CREATE_MATERIALS, {
        name: "createMaterials"
    }),
)(MaterialCreationModal))
);
